/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const EveningIcon = props => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 20 20'
			style={{
				enableBackground: 'new 0 0 20 20'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			{...props}
		>
			<path d='M8 3.7c.2.1.4.2.4.5 0 .1 0 .2-.1.3-.3.9-.4 1.8-.2 2.8.2 1.3.8 2.4 1.8 3.3.8.7 1.8 1.2 2.8 1.3 1 .2 2 .1 2.9-.3.2-.1.4-.1.6.1.2.1.2.4.1.6-.2.5-.5 1-.8 1.4-.9 1.2-2.2 2.1-3.7 2.4-2.4.6-5-.2-6.5-2.1-.9-1-1.4-2.3-1.6-3.6V9.3c0-.3.1-.6.1-.9.4-1.7 1.4-3.2 2.8-4.1.4-.3.8-.5 1.2-.6H8zm6.7 9.2c-2.1.4-4.3-.3-5.8-1.8-1.6-1.5-2.2-3.7-1.8-5.8-1.7 1.2-2.6 3.2-2.3 5.3.4 3 3.2 5.1 6.2 4.6 1.5-.2 2.8-1 3.7-2.3' />
		</svg>
	)
}

export default EveningIcon
